module.exports = __webpack_public_path__ + "css/Powercore.d6b398dc.css";